import artifact from '$houdini/artifacts/HomeSetUserSetting'
import { MutationStore } from '../runtime/stores/mutation'

export class HomeSetUserSettingStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
